import React from 'react';

const LanguagesContext = React.createContext({
    languageOptions: null
});

export default LanguagesContext;
